<template>
	<c-form v-show="fieldList.length" ref="form" name="custom_fields_value_json" link-parent>
		<c-title v-if="title">{{title}}</c-title>
		<c-form-item v-for="(item, i) in fieldList" :key="i" :label="item.field_title" :required="item.config_json.attr.includes('required')" :tip="item.config_json.tip">
			<scan-code v-if="item.config_json.type == 'text'" :parse="false" :disabled="!item.config_json.attr.includes('scan')" @success="scanHandle($event, item)">
				<c-input
					:type="item.config_json.attr.includes('textarea') ? 'textarea' : 'text'"
					:name="item.field_code"
					:disabled="item.config_json.attr.includes('readonly')"
					:placeholder="item.config_json.placeholder"
					@change="changeHandle(item)"
				></c-input>
			</scan-code>

			<c-input v-else-if="item.config_json.type == 'number'"
				type="number"
				:name="item.field_code"
				:decimal="item.config_json.attr.includes('decimal') ? item.config_json.decimal : 0"
				:disabled="item.config_json.attr.includes('readonly')"
				:placeholder="item.config_json.placeholder"
				@change="changeHandle(item)"
			></c-input>

			<c-datetime v-else-if="item.config_json.type == 'time'"
				:name="item.field_code"
				:type="item.config_json.format.split('|')[1]"
				:format="item.config_json.format.split('|')[0]"
				:time-accuracy="item.config_json.format.split('|')[2]"
				:disabled="item.config_json.attr.includes('readonly')"
				:placeholder="item.config_json.placeholder"
				@change="changeHandle(item)"
			></c-datetime>

			<template v-else-if="item.config_json.type == 'option'">
				<template v-if="item.config_json.mode == 'option'">
					<c-checkbox-group v-if="item.config_json.attr.includes('multiple')"
						:name="item.field_code"
						:options="item.config_json.options"
						@change="changeHandle(item)"
					></c-checkbox-group>

					<c-radio-group v-else
						:name="item.field_code"
						:options="item.config_json.options"
						@change="changeHandle(item)"
					></c-radio-group>
				</template>

				<c-select v-else
					:name="item.field_code"
					:options="item.config_json.options"
					:multiple="item.config_json.attr.includes('multiple')"
					:placeholder="item.config_json.placeholder || '请选择'"
					:search="{add: item.config_json.attr.includes('add')}"
					@add="addCustomOption(item, arguments[0], arguments[1])"
					@change="changeHandle(item)"
				></c-select>
			</template>

			<c-upload-file v-else-if="item.config_json.type == 'file'"
				:name="item.field_code"
				:type="item.config_json.suffix.join(',')"
				:multiple="item.config_json.attr.includes('multiple')"
				:sort="false"
			></c-upload-file>

			<c-upload-file v-else-if="item.config_json.type == 'image'"
				:name="item.field_code"
				type="image"
				media
				:multiple="item.config_json.attr.includes('multiple')"
				:sort="false"
			></c-upload-file>
		</c-form-item>
	</c-form>
</template>

<script>
	export default {
		name: 'customForm',

		props: {
			workType: [String, Number],
			title: String
		},

		data() {
			return {
				fieldList: []
			}
		},

		computed: {
			rule() {
				let rule = {};
				this.fieldList.map(item => {
					if (item.config_json.attr.includes('required')) {
						rule[`custom_fields_value_json.${item.field_code}`] = `${item.field_title}不能为空`
					}
				});
				return rule;
			},

			defaultData() {
				let data = {
					_default: true
				}, object = false;
				this.fieldList.map(item => {
					if (item.config_json.default) {
						if (item.config_json.default.type == 1) {
							if (item.config_json.type == 'time') {
								data[item.field_code] = new Date().format(item.config_json.format.split('|')[0]);
							} else {
								data[item.field_code] = item.config_json.default.value;
							}
						} else if (item.config_json.default.type == 2) {
							if (!object) {
								object = {};
							}
							object[item.field_code] = '';
						}
					}
				})

				return {
					data,
					object
				}
			}
		},

		mounted() {
			this._setFormData = this.$refs.form.set;
			this.$refs.form.set = data => {
				if (!data._default) {
					this._lastData = data;
				}
				this._setFormData(data);
			}
		},

		methods: {
			init() {
				this._lastData = false;
				this.request({
					url: '/sys_field/list',
					data: {
						work_type_id: this.workType
					},
					success: data => {
						this.$emit('init', data);
						this.fieldList = data;
						this.$nextTick(this.reset);

						if (this._defaultQueue) {
							this.$nextTick(() => {
								this._defaultQueue.forEach(item => {
									item();
								});
								delete this._defaultQueue;
							});
						}
					}
				});
			},

			reset() {
				this.$refs.form.clear();
				this._setFormData(this._lastData || this.defaultData.data);
				this._lastData = false;
			},

			addCustomOption(item, name, resolve) {
				let option = {
					name,
					value: name
				}
				this.request({
					url: '/sys_field/edit',
					data: {
						work_type_id: this.workType,
						id: item.id,
						field_title: item.field_title,
						config_json: JSON.stringify(Object.assign({}, item.config_json, {
							options: item.config_json.options.map(item => item).concat([option])
						}))
					},
					loading: true,
					success: () => {
						resolve(option);
					}
				});
			},

			setDefaultData(source) {
				let handler = () => {
					if (this.defaultData.object && source) {
						this.request({
							url: '/sys_field/default/values',
							data: source,
							success: data => {
								this.$refs.form.set(Object.assign({
									_default: true
								}, this.defaultData.object, data[0]));
							}
						})
					}
				}
				
				if (!this.fieldList.length) {
					if (!this._defaultQueue) {
						this._defaultQueue = [];
					}
					this._defaultQueue.push(handler);
				} else {
					handler();
				}
			},

			changeHandle(item) {
				if (this._events.change) {
					let data = this.$refs.form.get();
					this.$emit('change', {
						config: item.config_json,
						value: data[item.field_code]
					}, data);
				}
			},

			scanHandle(res, item) {
				if (item.config_json.attr.includes('textarea')) {
					let val = this.$refs.form.get()[item.field_code];
					this.$refs.form.set({
						[item.field_code]: val + (!val || val[val.length - 1] == '\n' ? '' : '\n') + res
					});
				} else {
					this.$refs.form.set({
						[item.field_code]: res
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
